import React from "react"
import ReactDOM from "react-dom"

import IconFont from "./IconFont"

const modalRootId = "modal-root"

export interface ModalProps {
  children: React.ReactNode
  title?: React.ReactNode | null
  subtitle?: React.ReactNode | null
  titleClassName?: string
  subtitleClassName?: string
  open?: boolean
  onClose?: () => void
  titleAlign?: 'center' | 'start'
}

export const Modal: React.FC<ModalProps> = ({
  children,
  title = null,
  subtitle = null,
  titleClassName = "",
  subtitleClassName = "",
  open = false,
  onClose,
  titleAlign = 'center'
}: ModalProps): React.ReactElement | null => {

  if (open === false) {
    return null
  }

  const hasHeader = Boolean(title || subtitle)
  const headerAlignmentClass = titleAlign === 'start'
    ? 'items-start text-left'
    : 'items-center text-center'
  const headerPlacementClass = titleAlign === 'start'
    ? 'justify-start pr-[40px]'
    : 'justify-center px-[40px]'

  return ReactDOM.createPortal(
    <>
      <div className="ui-layer-modal fixed inset-0 overflow-y-auto">
        <div className="flex items-center justify-center min-h-screen px-4">
          <button onClick={onClose} type="button" className="ui-modal-overlay modal-overlay ui-layer-modal" aria-label="Close modal"></button>
          <div className="modal-panel modal-panel-md ui-layer-modal-panel inline-block">
            <div className={`relative flex min-h-8 w-full items-center ${hasHeader ? headerPlacementClass : "justify-end"}`}>
              <button onClick={onClose} className="btn-modal-close !right-0 !top-0" aria-label="Close modal">
                <IconFont name="x" size={24} />
              </button>
              {hasHeader && (
                <div className={`flex flex-col gap-[4px] ${headerAlignmentClass}`}>
                  {title && <span className={`font-sans text-[16px] font-bold leading-[24px] tracking-normal text-heading ${titleClassName}`}>{title}</span>}
                  {subtitle && <p className={`m-0 text-sm text-body-muted ${subtitleClassName}`}>{subtitle}</p>}
                </div>
              )}
            </div>
            <div className="w-full">
              {children}
            </div>
          </div>
        </div>
      </div>
    </>,
    document.getElementById(modalRootId) || document.body
  )
}

export const ModalRootElement: React.FC = (): React.ReactElement => {
  return (<div id={modalRootId} />)
}

export const ModalConfirmationMessage: React.FC<{
  children: React.ReactNode;
  className?: string;
  suppressMaxWidth?: boolean;
}> = ({
  children,
  className = "",
  suppressMaxWidth = false,
}): React.ReactElement => (
  <div className={`type-body mx-auto mt-[16px] ${suppressMaxWidth ? "" : "max-w-[320px]"} text-center ${className}`}>
    {children}
  </div>
)
